import { matchRoutes } from 'react-router-dom';

import { pages, routes } from '@/modules/layouts/pages';

export const useCurrentPageConfig = () => {
  const matches = matchRoutes(routes, location);

  const pageConfig = matches
    ? pages.find((page) => page.path === matches[0]?.route.path)
    : undefined;

  return pageConfig;
};
